import { render, staticRenderFns } from "./AmazonSettlement.vue?vue&type=template&id=3ce59656&scoped=true"
import script from "./AmazonSettlement.vue?vue&type=script&lang=js"
export * from "./AmazonSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce59656",
  null
  
)

export default component.exports